<mat-form-field appearance="outline" bmTheme="find-tracks-select">
  <mat-label>{{ label }}</mat-label>

  @if (!multiple) {
    <mat-select [(value)]="value" (selectionChange)="onSingleChange($event)">
      <mat-option [value]="'all'">{{ allOptionLabel }}</mat-option>
      @for (item of items; track item.id) {
        <mat-option [value]="item.id">
          {{ item.title }}
        </mat-option>
      }
    </mat-select>
  }

  @if (multiple) {
    <mat-select multiple [(value)]="selectedIds" (selectionChange)="onMultipleChange($event)">
      @for (item of items; track item.id) {
        <mat-option [value]="item.id">
          {{ item.title }}
        </mat-option>
      }
    </mat-select>
  }
</mat-form-field>

@if (isModeToggleVisible) {
  <div class="dictionary-select__mode">
    <button
      type="button"
      class="dictionary-select__mode-button"
      [class.dictionary-select__mode-button--active]="mode === 'and'"
      (click)="toggleMode('and')"
    >
      {{ andLabel }}
    </button>
    <button
      type="button"
      class="dictionary-select__mode-button"
      [class.dictionary-select__mode-button--active]="mode === 'or'"
      (click)="toggleMode('or')"
    >
      {{ orLabel }}
    </button>
  </div>
}
